module.exports = __webpack_public_path__ + "static/media/dinner.4a0e877d.png";